"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    default: ()=>ErrorComponent_ErrorComponent
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
require("react");
const external_ErrorComponent_styles_js_namespaceObject = require("./ErrorComponent.styles.js");
const external_ErrorImg_js_namespaceObject = require("./ErrorImg.js");
var external_ErrorImg_js_default = /*#__PURE__*/ __webpack_require__.n(external_ErrorImg_js_namespaceObject);
const ErrorComponent = ()=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ErrorComponent_styles_js_namespaceObject.ErrorImgWrapper, {
                "data-testid": "error-img-wrapper",
                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ErrorImg_js_default(), {})
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_ErrorComponent_styles_js_namespaceObject.ErrorTextWrapper, {
                bg: "warning.light",
                mx: 3,
                borderRadius: 12,
                py: 2,
                px: 12,
                "data-testid": "error-text-wrapper",
                children: [
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("span", {
                        children: "Lost in the Clouds. "
                    }),
                    " We're sorry, something seems to have gone wrong. Please try again in a little bit."
                ]
            })
        ]
    });
const ErrorComponent_ErrorComponent = ErrorComponent;
exports["default"] = __webpack_exports__["default"];
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "default"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
